import React from "react";
import { useNavigate } from "react-router-dom";

const COPY = {
  shortlisted: {
    icon: "📋",
    title: "No candidates shortlisted",
    body: "Candidates will appear here as they reach the shortlisted stage.",
    cta: { label: "Go to Interviews", to: "/admin/interviews" },
  },
  offered: {
    icon: "✉️",
    title: "No offers extended",
    body: "Candidates will appear here when an offer is sent.",
    cta: { label: "Go to Interviews", to: "/admin/interviews" },
  },
  hired: {
    icon: "🎉",
    title: "No candidates hired",
    body: "Candidates will appear here once they accept an offer.",
    cta: { label: "Go to Interviews", to: "/admin/interviews" },
  },
};

export default function StageEmptyState({ stage, emptyCta }) {
  const nav = useNavigate();
  const c = COPY[stage] || COPY.shortlisted;
  const ctaLabel = emptyCta?.label || c.cta.label;
  const ctaTo = emptyCta?.to || c.cta.to;
  return (
    <div className="bg-white border border-slate-200 rounded-xl py-16 px-6 text-center">
      <div className="text-4xl mb-3">{c.icon}</div>
      <div className="text-base font-semibold text-vf-base mb-1">{c.title}</div>
      <div className="text-sm text-vf-muted max-w-md mx-auto mb-5">
        {c.body}
      </div>
      <button
        onClick={() => nav(ctaTo)}
        className="px-3 py-1.5 rounded bg-vf-primary text-white text-xs font-medium"
      >
        {ctaLabel}
      </button>
    </div>
  );
}
